// extracted by mini-css-extract-plugin
module.exports = {"dsWrapper":"shared-App__dsWrapper--RyVET","app":"shared-App__app--3IXkP"};